import { type CSSProperties, useMemo } from 'react';

import classnames from 'classnames';

import { PlatformShareButton } from '@/ui/PlatformShareButton';

import { baseContainer } from './PostShare.css';
import type { PostShareElementProps } from './PostShare.types';

const PLATFORMS = ['email', 'meta', 'x', 'threads', 'linkedIn', 'reddit', 'whatsApp'];

export function PostShareElement(props: PostShareElementProps) {
  const { element, children, attributes } = props;

  const {
    color,
    backgroundColor,
    flexDirection,
    mobileFlexDirection,
    gap,
    mobileGap,
    size,
    borderStyle,
    borderColor,
    borderWidth,
    borderRadius,
    padding,
    platforms,
    data,
  } = element.attrs || {};

  const mappedFilteredPlatforms = useMemo(() => {
    return PLATFORMS.filter((platform) => platforms?.[platform] === true).map((platform) => (
      <PlatformShareButton
        key={platform}
        platform={platform}
        title={data?.title || ''}
        url={data?.url || ''}
        size={size}
        color={color}
        backgroundColor={backgroundColor}
        padding={padding}
        borderStyle={borderStyle}
        borderColor={borderColor}
        borderWidth={borderWidth}
        borderRadius={borderRadius}
      />
    ));
  }, [platforms, data, size, color, backgroundColor, padding, borderStyle, borderColor, borderWidth, borderRadius]);

  return (
    <div
      className={classnames('w-fit flex relative', baseContainer)}
      style={
        {
          '--gap': gap,
          '--mobile-gap': mobileGap,
          '--flex-direction': flexDirection,
          '--mobile-flex-direction': mobileFlexDirection,
        } as CSSProperties
      }
      {...attributes}
    >
      {mappedFilteredPlatforms}
      {children}
    </div>
  );
}
